export default {"src":"/_next/static/media/azuro_wave.f97a9551.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};